import { displayError, displayWarning } from "../../utils/messageToast";
import { displaySuccess } from "../../utils/messageToast";
import { SetupFlowRC } from "../../client";

export const tabulateTickets = async (
  tabId: string,
  setTabId: React.Dispatch<React.SetStateAction<string>>,
  ambient: string,
  authorization: string,
  authorizationRA: string,
  setTextAreaValue: React.Dispatch<React.SetStateAction<any>>,
  publicNote: string,
  setPublicNote: React.Dispatch<React.SetStateAction<string>>,
  privateNote: string,
  setPrivateNote: React.Dispatch<React.SetStateAction<string>>,
  protocols: any[],
  setProtocols: React.Dispatch<React.SetStateAction<any[]>>,
  setErrors: React.Dispatch<React.SetStateAction<any[]>>,
  setSuccesses: React.Dispatch<React.SetStateAction<any[]>>,
  userId?: string,
  userName?: string | null,
  clientId?: string | null,
  clientName?: string | null,
  isInForce?: boolean,
) => {
  try {
    const apiClient = SetupFlowRC(authorizationRA, authorization);
    const response = await apiClient.post(
      `/tabulation-ticket?ambient=${ambient}&tabId=${tabId}&isInForce=${Boolean(isInForce)}`,
      {
        text: protocols,
        publicNote,
        privateNote,
        userId,
        userName,
        clientId,
        clientName,
      }
    );

    const errorsList = response.data.errors ?? [];
    const successesList = response.data.successes ?? [];

    setErrors(errorsList);
    setSuccesses(successesList);

    const hasErrors = errorsList.length > 0;
    const hasSuccesses = successesList.length > 0;

    if (hasErrors && hasSuccesses) {
      displayWarning(
        "Tabulação parcial: alguns protocolos foram tabulados e outros falharam. Veja os detalhes abaixo."
      );
    } else if (hasErrors) {
      displayWarning("Não foi possível tabular todos os tickets. Veja os detalhes abaixo.");
    } else {
      displaySuccess("Tickets tabulados com sucesso!");
    }

    setTextAreaValue("");
    setProtocols([]);
    setPublicNote("");
    setPrivateNote("");
    setTabId("");
    return;
  } catch (error: any) {
    displayError("Erro ao tabular tickets!");
    return;
  }
};
